import { TAssetEditorProp } from '../../assetEditorProps'
import {
    AMAObject,
    isCamera,
    isDirectionalLight,
    isHemisphereLight,
    isMeshAMA,
    isPointLight,
    isSpotLight,
    utilsEditor
} from '@amaspace-editor/editor-3d'
import * as THREE from 'three'
import { isLight } from '../../../../../utils'
import { AMAMeshType } from '@amaspace-editor/editor-3d'

const currentObjectsData = (editor3D: ReturnType<typeof utilsEditor>): TAssetEditorProp[] => {
    if (!editor3D.activeMesh) return [] as TAssetEditorProp[]

    const light = editor3D.activeMesh.children[0]
    const camera = editor3D.activeMesh.children[0]
    const cameraConfig = editor3D.getCurrentConfigObj(editor3D.activeMesh)

    const customTargets = () => {
        const defaultValue = { name: 'None', id: '' }
        const targets: AMAObject[] = editor3D.config.customObjects.filter(x => x.type === AMAMeshType.Target)

        return [defaultValue, ...targets].map(target => {
            return {
                label: target.name,
                value: target.id,
                key: `${target.id}_target`
            }
        })
    }
    const allNodes = () => {
        const defaultValue = { name: 'None', id: '', userData: { id: '' } }
        const nodes: AMAObject[] = editor3D.config.objects

        return [defaultValue, ...nodes].map(node => {
            console.log(node)
            return {
                label: node.name,
                value: node.userData?.id,
                key: `${node?.userData?.id}_target`
            }
        })
    }
    if (isMeshAMA(editor3D.activeMesh)) {
        const defaultCameraProps: TAssetEditorProp[] = [
            { type: 'input', label: 'Name', value: editor3D?.activeMesh?.name, key: 'name_prop' },
            { type: 'tuple', label: 'Position', value: editor3D?.activeMesh?.position, key: 'position_prop' },
            {
                type: 'select',
                label: 'Target',
                value: { options: customTargets(), value: isCamera(cameraConfig) && cameraConfig?.target?.object },
                key: 'camera_target'
            }
        ]

        const defaultProps: TAssetEditorProp[] = [
            { type: 'input', label: 'Name', value: editor3D?.activeMesh?.name, key: 'name_prop' },
            { type: 'tuple', label: 'Position', value: editor3D?.activeMesh?.position, key: 'position_prop' },
            { type: 'tuple', label: 'Rotation', value: editor3D?.activeMesh?.rotation, key: 'rotation_prop' },
            { type: 'tuple', label: 'Scale', value: editor3D?.activeMesh?.scale, key: 'scale_prop' },
            { type: 'switch', label: 'Visible', value: editor3D?.activeMesh?.visible, key: 'visible_prop' },
            {
                type: 'switch',
                label: 'Visible in AR',
                value: editor3D?.getCurrentConfigObj(editor3D?.activeMesh)?.userData?.visibleInAR,
                key: 'visibleInAR_ar'
            },
            { type: 'switch', label: 'Shadow cast', value: editor3D?.activeMesh?.castShadow, key: 'castShadow_prop' },
            {
                type: 'switch',
                label: 'Shadow recieve',
                value: editor3D?.activeMesh?.receiveShadow,
                key: 'receiveShadow_prop'
            }
        ]

        if (camera instanceof THREE.PerspectiveCamera) return defaultCameraProps
        if (!isLight(light)) return defaultProps

        const defaultLightProps: TAssetEditorProp[] = [
            { type: 'tuple', label: 'Position', value: editor3D.activeMesh?.position, key: 'position_prop' },
            { type: 'range', label: 'Intensive', value: light.intensity, key: 'intensity' },
            { type: 'switch', label: 'Visible', value: editor3D.activeMesh.visible, key: 'visible_scene' },
            { type: 'switch', label: 'Shadow cast', value: light.castShadow, key: 'castShadow_light' },
            { type: 'color', label: 'Color', value: light.color, key: 'color_light' }
        ]

        if (isDirectionalLight(light)) return defaultLightProps
        if (isPointLight(light)) return defaultLightProps
        if (isHemisphereLight(light)) return defaultLightProps
        if (isSpotLight(light)) {
            return defaultLightProps.concat([
                { type: 'range', label: 'Angle', value: light.angle, key: 'angle', misc: { max: 2 } }
            ])
        }
    }
    return [
        { type: 'input', label: 'Name', value: editor3D?.activeMesh?.name, key: 'name_prop' },
        { type: 'tuple', label: 'Position', value: editor3D?.activeMesh?.position, key: 'position_prop' },
        { type: 'switch', label: 'Visible', value: editor3D?.activeMesh?.visible, key: 'visible_prop' },
        {
            type: 'switch',
            label: 'Visible in AR',
            value: editor3D?.getCurrentConfigObj(editor3D?.activeMesh)?.userData?.visibleInAR,
            key: 'visibleInAR_ar'
        },
        {
            type: 'select',
            label: 'Parent',
            value: { options: allNodes(), value: editor3D.activeMesh?.userData?.parent },
            key: 'node_parent'
        }
    ]
    // return [] as TAssetEditorProp[]
}
export { currentObjectsData }
